import { createTheme } from "@material-ui/core/styles";

// Custom Mui Theme for our project
const theme = createTheme({
  palette: {
    primary: {
      main: "#00afc6", // "#2c3ff3"
      opacity: "rgba(0, 175, 198, .15)",
      opacity2: "rgba(0, 175, 198, .3)",
      contrastText: "#fff"
    },
    // secondary: {
    //   main: "#999",
    // },
    error: {
      main: "#f44336"
    },
    text: {
      secondary: "#91919F"
    }
  },
  overrides: {
    MuiAppBar: {
      root: {
        boxSizing: "border-box"
      }
    },
    MuiTypography: {
      colorSecondary: {
        color: "#666"
      }
    },
    MuiMenu: {
      paper: {
        maxHeight: "100%",
        padding: "0 !important"
      }
    },
    MuiButton: {
      root: {
        zIndex: 9,
        padding: "7px 16px",
        borderRadius: 6,
        textTransform: "none"
      },
      label: {
        whiteSpace: "nowrap"
      },
      outlined: {
        padding: "6px 15px"
      },
      text: {
        padding: "9px 16px"
      },
      contained: {
        boxShadow: "none"
      }
      // containedSizeSmall: {
      //   padding: "0 10px !important",
      //   height: "32px !important",
      //   "& .MuiButton-label": {
      //     padding: "0 !important",
      //   },
      // },
      // textSecondary: {
      //   color: "#666",
      // },
      // containedSecondary: {
      //   backgroundColor: "#bbb !important",
      //   color: "#fff !important",
      //   "&&:hover": {
      //     backgroundColor: "#aaa !important",
      //   },
      // },
      // label: {
      //   padding: "0 10px",
      //   minHeight: "40px",
      // },
    },
    MuiIconButton: {
      root: {
        alignSelf: "center"
      }
    },
    MuiPaper: {
      rounded: {
        padding: 24,
        borderRadius: 20
        // marginBottom: 24,
      },
      elevation4: {
        boxShadow: "0 2px 10px rgba(51,51,51,0.1)"
      },
      elevation8: {
        boxShadow: "0 2px 9px rgba(0,0,0,0.1)",
        border: "1px solid #E6E6E6",
        borderRadius: 8
      }
    },
    MuiDialog: {
      paper: {
        borderRadius: 6
      }
    },
    MuiPickersPopper: {
      paper: {
        padding: 0
      }
    },
    MuiInputLabel: {
      formControl: {
        top: -2
      }
    }
    // MuiSvgIcon: {
    //   colorSecondary: {
    //     color: "#666 !important",
    //   },
    // },
  }
});

export default theme;
